import { FilterModel, ColumnState} from '@ag-grid-community/core';
export enum SettingsKey {
  TASKS_GRID = 'TASKS_GRID'
}

export interface GridState {
  name: string;
  filterModel: FilterModel;
  columnState: ColumnState[];
  showMsg?: boolean;
}

export interface UserSettings {
  key: SettingsKey;
  value: string;
}
